import React from "react";


export default function Products() {
    return (
        <section className="products">
            <img src={require("../images/20190430_064859.jpg")} alt="Masonry wall construction"/>
            <div className="container grid-1 features">
            <FeatureCard
            title="Walls & Fountain Installations"
            text="From decorative garden fountains to robust boundary and retaining walls, we deliver full-service masonry and hardscape solutions tailored to Southern Arizona’s desert terrain. Whether you’re creating a tranquil backyard water feature, installing a stylish block wall for privacy, or building retaining walls to manage slope and drainage, our team handles design, permitting, installation, and finishes. With our experience in the region’s sun-baked soils and flash-flood risk, we build walls and water features that look great and stand the test of time."
            />
            <FeatureCard
            title="Custom Steel Gate Fabrication & Installation"
            text="Add security, curb-appeal, and value with a custom steel gate designed for Arizona living. We provide one-stop fabrication and installation of driveway gates, pedestrian gates, RV/boat access gates, and more. We work with premium steel, heavy-duty hardware, and powder-coatings made to withstand the desert sun and oxidizing conditions. From design consultation through on-site installation—including automation options, remote entry systems, and durable finishes—we ensure your gate complements your home’s aesthetic and functions reliably in the Southern Arizona environment."
            />
            <FeatureCard
            title="Residential House Builds & Concrete Slab Foundations"
            text="Whether you plan a new single-family home, an accessory dwelling unit (ADU), or a slab addition (garage, shop, patio), we provide full general-contracting services from site prep through final walk-through. We specialize in foundations and slab-on-grade systems engineered for Southern Arizona’s expansive soils, high heat, and local building requirements. Our services include excavation, rebar/mesh reinforcement, moisture-barriers, proper compaction and concrete placement, as well as home framing, utilities coordination, and finishing. Trust us to deliver a structurally sound base and a completed home building project that’s ready for occupancy."
            />
            </div>
        </section>
    );
}

function FeatureCard({ title, text}) {
    return (
        <article className="card">
        <div className="card-body">
        <h3>{title}</h3>
        <p>{text}</p>
        </div>
        </article>
    );
}